/**
 * @generated SignedSource<<129368bb5c842a831c36b9d79b949315>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HsUpdateSettingsInput = {
  clientMutationId?: string | null | undefined;
  contactProperties?: ReadonlyArray<JSONKeyValueArrayInput | null | undefined> | null | undefined;
  defaultOwnerId?: string | null | undefined;
};
export type JSONKeyValueArrayInput = {
  key?: string | null | undefined;
  value?: string | null | undefined;
};
export type Integration_HsUpdateSettings_Mutation$variables = {
  input: HsUpdateSettingsInput;
};
export type Integration_HsUpdateSettings_Mutation$data = {
  readonly hsUpdateSettings: {
    readonly allowedContactProperties: ReadonlyArray<{
      readonly key: string | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly contactProperties: ReadonlyArray<{
      readonly key: string | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type Integration_HsUpdateSettings_Mutation = {
  response: Integration_HsUpdateSettings_Mutation$data;
  variables: Integration_HsUpdateSettings_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HsUpdateSettingsPayload",
    "kind": "LinkedField",
    "name": "hsUpdateSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "JSONKeyValue",
        "kind": "LinkedField",
        "name": "allowedContactProperties",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "JSONKeyValue",
        "kind": "LinkedField",
        "name": "contactProperties",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_HsUpdateSettings_Mutation",
    "selections": (v2/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Integration_HsUpdateSettings_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "109a66c2e7ab38b2c7af48fc34204234",
    "id": null,
    "metadata": {},
    "name": "Integration_HsUpdateSettings_Mutation",
    "operationKind": "mutation",
    "text": "mutation Integration_HsUpdateSettings_Mutation(\n  $input: HsUpdateSettingsInput!\n) {\n  hsUpdateSettings(input: $input) {\n    allowedContactProperties {\n      key\n      value\n    }\n    contactProperties {\n      key\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "12961253c74891ac34f625eb1e73954e";

export default node;
